import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import orgConfig from 'org/configs/org.config';
import { selectSiteUrl } from 'core/selectors/app';

import { triggerStickyFooterButtonIsViewed } from '../actions';

export function StickyFooterButton({ config }) {
  const { earnType } = orgConfig;
  const siteUrl = useSelector(selectSiteUrl);
  const dispatch = useDispatch();

  const { stickyFooterButton: { buttonImage, buttonCTA } } = config;

  useEffect(() => {
    dispatch(triggerStickyFooterButtonIsViewed());
  }, []);

  return (
    <>
      <div className="mn_imageWrap">
        <img className="mn_image mn_buttonImage" src={buttonImage} alt="" />
      </div>
      <div className="mn_info">
        <h3>Earn {earnType}, find deals, & apply coupons with the push of a button<span className="mn_dot">.</span></h3>
      </div>
      <div className="mn_buttonWrap">
        <a href={`${siteUrl}/button`} className="mn_button">{buttonCTA}</a>
      </div>
    </>
  );
}

export default StickyFooterButton;
